import { useTranslation } from '@hotjar/translations';
import { EmptyState } from '@hotjar/webapp/components/EmptyState';

import ErrorConsoleIllustration from '../../assets/images/error-console-illustration.svg';

interface Props {
  onUpgradeClick: () => unknown;
}

export const ErrorConsoleEmptyStateUpsell = ({ onUpgradeClick }: Props): JSX.Element => {
  const { t } = useTranslation('upsell', { keyPrefix: 'error-console-empty-state' });

  return (
    <EmptyState
      kind="condensed"
      img={ErrorConsoleIllustration}
      title={t('title')}
      subtitle={t('description')}
      buttonIcon="crown"
      buttonText={t('cta')}
      buttonKind="secondary"
      onButtonClick={onUpgradeClick}
    />
  );
};
